import React from "react";
import { Container, Grid, Typography, Button, Box, Link } from "@mui/material";
import { UserInfoProps } from "../../types"; // Importamos las interfaces desde el archivo 'types.ts'

export const Resumen: React.FC<UserInfoProps> = ({ userData }) => {
    console.log('ariel',userData);
    return (
        <Box 
        sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#f5f5f5",
            height:"450px",
            p:3,            
        }}>
            <Grid container spacing={4} sx={{marginTop:'1em'}}>
                {/* Información General */}
                <Grid size={{ xs: 6, md: 12 }}>
                <Typography variant="h6" fontWeight="bold">Información General</Typography>
                <Typography><strong>Documentos:</strong> {userData?.nrodoc || "No especificado"}</Typography>
                <Typography><strong>Teléfono:</strong> {userData?.telefono || "No especificado"}</Typography>
                <Typography><strong>Correo Electrónico:</strong> {userData?.usuario || "No especificado"}</Typography>
                <Typography><strong>Nombre de usuario:</strong> {userData?.username || "No especificado"}</Typography>
                <Typography>
                    <strong>Listas:</strong>
                    <Button size="small" color="warning">Añadir a lista</Button>
                </Typography>
                <Typography><strong>Observaciones:</strong> {userData?.observaciones || "Ninguna"}</Typography>
                </Grid>

                {/* Estado de Pagos */}
                {/* <Grid size={{ xs: 6, md: 12 }}>
                <Typography variant="h6" fontWeight="bold">Estado de Pagos</Typography>
                <Typography color="#2FC273">Pagado: {userData?.pagos?.pagado || "No especificado"}€</Typography>
                <Typography color="#3F92B6">Pendiente: {userData?.pagos?.pendiente || "No especificado"}€</Typography>
                <Typography color="#AD4C4F">No pagado: {userData?.pagos?.no_pagado || "No especificado"}€</Typography>
                <Typography color="#FFC140">Anulado: {userData?.pagos?.anulado || "No especificado"}€</Typography>
                <Box mt={2}>
                    <Link href="#" color="#0D85B3">Movimientos →</Link>
                </Box>
                </Grid> */}
            </Grid>
        </Box>
    );
};
